/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { REQUEST_STATE } from '../utils';
import {
  getUserAsync,
  loginAsync,
  logoutAsync,
  editProfileAsync,
} from './thunks';

const INITIAL_STATE = {
  list: [],
  user: {},
  isLoggedIn: false,
  getUser: REQUEST_STATE.IDLE,
  login: REQUEST_STATE.IDLE,
  logout: REQUEST_STATE.IDLE,
  join: REQUEST_STATE.IDLE,
  editProfile: REQUEST_STATE.IDLE,
  error: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState: INITIAL_STATE,
  reducers: {
    resetUserState: () => INITIAL_STATE,
    setLoginStatus: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserAsync.pending, (state) => {
        state.getUser = REQUEST_STATE.PENDING;
        state.error = null;
      })
      .addCase(getUserAsync.fulfilled, (state, action) => {
        state.getUser = REQUEST_STATE.FULFILLED;
        state.user = action.payload;
      })
      .addCase(getUserAsync.rejected, (state, action) => {
        state.getUser = REQUEST_STATE.REJECTED;
        state.error = action.error?.message || action.error;
      })
      .addCase(loginAsync.pending, (state) => {
        state.login = REQUEST_STATE.PENDING;
        state.error = null;
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.login = REQUEST_STATE.FULFILLED;
        state.isLoggedIn = true;
        state.user = action.payload;
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.login = REQUEST_STATE.REJECTED;
        state.error = action.payload;
      })
      .addCase(logoutAsync.pending, (state) => {
        state.logout = REQUEST_STATE.PENDING;
        state.error = null;
      })
      .addCase(logoutAsync.fulfilled, (state, action) => {
        state.logout = REQUEST_STATE.FULFILLED;
        state.isLoggedIn = false;
        state.user = null;
      })
      .addCase(logoutAsync.rejected, (state, action) => {
        state.logout = REQUEST_STATE.REJECTED;
        state.error = action.error?.message || action.error;
      })
      .addCase(editProfileAsync.pending, (state) => {
        state.editProfile = REQUEST_STATE.PENDING;
        state.error = null;
      })
      .addCase(editProfileAsync.fulfilled, (state, action) => {
        state.editProfile = REQUEST_STATE.FULFILLED;
        state.user = action.payload;
      })
      .addCase(editProfileAsync.rejected, (state, action) => {
        state.editProfile = REQUEST_STATE.REJECTED;
        state.error = action.error?.message || action.error;
      });
  },
});

export const { resetUserState, setLoginStatus, setUser } = usersSlice.actions;
export default usersSlice.reducer;
